import Amplify, { API } from "aws-amplify";
import { withAuthenticator } from "aws-amplify-react";
import * as React from "react";
import { Viewport } from "react-map-gl";

import aws_exports from "./aws-exports";
import Map from "./components/Map";
import logo from "./logo.png";

import "./App.css";

Amplify.configure(aws_exports);

interface IState {
  trailers: ITrailer[];
  searchInput: string;
  viewport: Viewport;
  currentMarker: IMarker;
}
interface IMarker {
  latitude: number;
  longitude: number;
}

export interface ITrailer {
  serialNumber: string;
  latitude: number;
  longitude: number;
}

const defaultLat = 34.2012336;
const defaultLng = -87.6338292;
const defaultZoom = 17;

const initialViewport: Viewport = {
  latitude: defaultLat,
  longitude: defaultLng,
  zoom: defaultZoom
};

const initalMarker: IMarker = {
  latitude: defaultLat,
  longitude: defaultLng
};

class App extends React.Component<object, IState> {
  constructor(props: object) {
    super(props);
    this.state = {
      searchInput: "",
      trailers: [],
      viewport: initialViewport,
      currentMarker: initalMarker
    };
    this.renderMapbox = this.renderMapbox.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.searchForTrailer = this.searchForTrailer.bind(this);
    this.handleViewportChange = this.handleViewportChange.bind(this);
  }

  public render() {
    return (
      <div className="App">
        <header className="App-header">
          <img src={logo} className="App-logo" alt="logo" />
          <h1 className="App-title">YARD INVENTORY</h1>
        </header>
        {this.renderMapbox()}
        <div className="container app-intro">
          <p className="App-intro">
            To get started, enter a serial number and click search.
          </p>
          <div className="input-group search-input-group">
            <input
              onChange={this.handleChange}
              type="text"
              placeholder="Enter Serial Number..."
              className="form-control"
              maxLength={5}
              style={{ maxWidth: "250px" }}
            />
            <button className="btn btn-danger" onClick={this.searchForTrailer}>
              Search
            </button>
          </div>
        </div>
      </div>
    );
  }

  private async searchForTrailer() {
    const trailers: ITrailer[] = await API.get(
      "trailers",
      `/trailers/${this.state.searchInput}`,
      null
    );
    let newViewport: Viewport;
    let newMarker: IMarker;
    if (trailers.length) {
      const trailer = trailers[0];
      newViewport = {
        latitude: trailer.latitude,
        longitude: trailer.longitude,
        zoom: defaultZoom
      };
      newMarker = {
        latitude: trailer.latitude,
        longitude: trailer.longitude
      };
    } else {
      newViewport = initialViewport;
      newMarker = initalMarker;
    }

    await this.setState({
      trailers,
      viewport: newViewport,
      currentMarker: newMarker
    });
  }

  private handleChange(event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ searchInput: event.target.value });
  }

  private renderMapbox() {
    const { trailers } = this.state;
    if (!trailers.length) {
      return (
        <Map
          onViewportChange={this.handleViewportChange}
          viewport={this.state.viewport}
          currentMarker={this.state.currentMarker}
        />
      );
    } else if (trailers.length > 1) {
      this.renderTrailerLinks(trailers);
    }
    const trailer = trailers[0];
    return (
      <Map
        trailer={trailer}
        onViewportChange={this.handleViewportChange}
        viewport={this.state.viewport}
        currentMarker={this.state.currentMarker}
      />
    );
  }

  private renderTrailerLinks(trailers: ITrailer[]) {
    return trailers.map((trailer: ITrailer) => (
      <a onClick={this.handleLinkClick}>{trailer.serialNumber}</a>
    ));
  }

  private handleLinkClick(event: React.MouseEvent<HTMLAnchorElement>) {
    event.preventDefault();
    this.setState({ searchInput: event.currentTarget.innerHTML });
    this.searchForTrailer();
  }

  private handleViewportChange(viewport: Viewport) {
    // tslint:disable-next-line
    console.log(viewport);
    this.setState({ viewport });
  }
}

export default withAuthenticator(App);



// WEBPACK FOOTER //
// ./src/App.tsx